import { useEffect } from "react";

export function SidePanel({
  title,
  onClose,
  width = 520,
  children,
}: {
  title: string;
  onClose: () => void;
  width?: number;
  children: React.ReactNode;
}) {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => { if (e.key === "Escape") onClose(); };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);
  return (
    <div className="fixed inset-0 z-30 flex">
      <div className="flex-1 bg-black/40" onClick={onClose} />
      <aside
        className="bg-panel border-l border-edge h-full overflow-auto scroll-thin"
        style={{ width }}
      >
        <header className="flex items-center border-b border-edge px-4 h-11 sticky top-0 bg-panel">
          <div className="font-semibold text-sm truncate">{title}</div>
          <button
            onClick={onClose}
            className="ml-auto text-mist hover:text-white text-lg leading-none"
          >×</button>
        </header>
        <div className="p-4">{children}</div>
      </aside>
    </div>
  );
}
